import { Icon } from '@iconify/react'

import { PageLoadingProps } from '~/types/component'

const PageLoading = ({ children }: PageLoadingProps) => {
  return (
    <div className="flex items-center gap-4 rounded-lg bg-white p-10 text-jba-blue shadow-md">
      <Icon icon="material-symbols:progress-activity" className="animate-spin text-xl" />
      {children}
    </div>
  )
}

export default PageLoading
